import { apiBaseURL } from "../ProjectConstants";

async function handlePostDenyPurchaseOrder(comment, orderId, fetch) {
  const response = await fetch.post(
    `${apiBaseURL}/api/Approval/Deny/PurchaseOrder?purchaseOrderId=${orderId}&comment=${comment}`,
  );
  const isDataGood =
    response?.success &&
    response?.data?.statusCode &&
    response?.success !== "Invalid Model";

  return {
    response,
    isDataGood,
  };
}
export default handlePostDenyPurchaseOrder;
